import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output} from '@angular/core';
import {TimestampsService} from '../timestamps.service';
import {TradingInstrumentDisplayNameService} from '../trading-instruments/trading-instrument-display-name.service';
import {ActionItemEventWireDto, ActionItemWireDto} from '../shell-communication/action-board-operations';
import {ActionItemView, describeEvent, describeItem} from './action-item-view';

/**
 * CR-20260922-001 — the reading pane (owner 2026-09-22, Session Messages / Gmail style): the selected
 * item's header, subject, detail, attention / completion timeline, record and action buttons, in the
 * right-hand split area. Buttons write the lifecycle only on the recipient's own board.
 */
@Component({
    selector: 'ets-action-board-detail',
    templateUrl: './action-board-detail.component.html',
    styleUrls: ['./action-board-detail.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActionBoardDetailComponent implements OnChanges {

    constructor(
        private readonly _timestamps: TimestampsService,
        private readonly _displayNames: TradingInstrumentDisplayNameService
    ) {
    }

    @Input() item: ActionItemWireDto;
    @Input() todayDayKey: string;
    @Input() isOwnBoard: boolean;
    @Input() ownUserId: string;
    @Input() record: ActionItemEventWireDto[] | null;

    @Input() canMarkUnread: boolean;
    /** CR-20260924-001 F4a: false = the panel the item would open is not granted; Open is not offered. */
    @Input() openGranted = true;
    /** The record (audit trail) at the bottom is for super users only (owner 2026-09-22). */
    @Input() showRecord: boolean;

    @Output() close = new EventEmitter<void>();
    @Output() markUnread = new EventEmitter<ActionItemWireDto>();
    @Output() acknowledge = new EventEmitter<ActionItemWireDto>();
    @Output() openSubject = new EventEmitter<ActionItemWireDto>();
    @Output() withdraw = new EventEmitter<ActionItemWireDto>();

    view: ActionItemView;

    private get zone(): string | null {
        return this._timestamps.getDefaultTimezone() || null;
    }

    ngOnChanges(): void {
        if (this.item) {
            this.view = describeItem(this.item, this.todayDayKey, this.zone, t => this._displayNames.getOptionDisplayName(t));
            if (!this.openGranted) {
                this.view = {...this.view, canOpen: false};
            }
        }
    }

    get canWithdraw(): boolean {
        return !!this.item && this.item.itemType === 'Notice' && !this.view.isDone && !!this.item.senderUserId
            && this.item.senderUserId === this.ownUserId && !this.isOwnBoard;
    }

    formatEvent(e: ActionItemEventWireDto): string {
        return describeEvent(e, this.zone);
    }
}
